/* global.js — tiny helpers loaded early */
window.Gear = window.Gear || {};
window.Gear.formatMoney = function (cents) {
  try {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Gear.currency || 'INR' });
  } catch (e) {
    return '$' + (cents / 100).toFixed(2);
  }
};
